// valida se o domínio do email é gmail.com, hotmail.com ou yahoo.com
export const validateEmail = (email) => {
  const pattern =
    "[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](gmail|hotmail|yahoo|outlook)";
  const regex = new RegExp(pattern);
  return regex.test(email);
};
